import { configurationKeys, type WorkspaceKey } from '@festina-life/api'
import { useQueryClient } from '@tanstack/react-query'
import { useMemo } from 'react'

import { usePushWorkspaceOperationsToConfigurationComponent } from '../api/templateCreateOperations/usePushWorkspaceOperationsToConfigurationComponent'

export const usePushWorkspaceToBaseBranch = (workspaceKey: WorkspaceKey) => {
  const queryClient = useQueryClient()

  const { mutateAsync, isPending, error } =
    usePushWorkspaceOperationsToConfigurationComponent({
      server: workspaceKey.branchKey.server,
      workspaceName: workspaceKey.name,
    })

  return useMemo(
    () => ({
      mutateAsync: ({ description }: { description: string }) =>
        mutateAsync(
          { description },
          {
            onSuccess: () => {
              void queryClient.invalidateQueries({
                queryKey: [configurationKeys.allConciseBranchesKeyPrefix],
              })

              void queryClient.invalidateQueries({
                queryKey: configurationKeys.fetchConciseBranchKeyPrefix({
                  server: workspaceKey?.branchKey.server,
                  branchName: workspaceKey?.branchKey.name,
                }),
              })
              void queryClient.invalidateQueries({
                queryKey: configurationKeys.fetchBranchAllErrorsPrefix({
                  server: workspaceKey?.branchKey.server,
                  branchName: workspaceKey?.branchKey.name,
                }),
              })

              void queryClient.invalidateQueries({
                queryKey:
                  configurationKeys.fetchWorkspaceBaseBranchChangesetsKey({
                    server: workspaceKey.branchKey.server,
                    workspaceName: workspaceKey.name,
                  }),
              })
            },
          },
        ),
      isPending,
      error,
    }),
    [
      error,
      isPending,
      mutateAsync,
      queryClient,
      workspaceKey.branchKey.name,
      workspaceKey.branchKey.server,
      workspaceKey.name,
    ],
  )
}
